<div class="tp-page">
  <h1 class="tp-page-title">{{ message }}</h1>

  <div *ngIf="message == 'Mes transactions'">
    <div class="tp-tabs" role="tablist">
      <button type="button" role="tab" class="tp-tab"
        [class.is-active]="activeTabIndex === 0" (click)="selectTab(0)">
        Transactions
      </button>
      <button type="button" role="tab" class="tp-tab"
        [class.is-active]="activeTabIndex === 1" (click)="selectTab(1)">
        Mes remboursements
      </button>
    </div>

    <app-transactions *ngIf="activeTabIndex === 0"></app-transactions>
    <app-remboursements *ngIf="activeTabIndex === 1"></app-remboursements>
  </div>

  <div *ngIf="message == 'Mon solde'"><app-soldes></app-soldes></div>
  <div *ngIf="message == 'Mon Qr-Code'"><app-qr-code></app-qr-code></div>
  <div *ngIf="message == 'Mes boutiques & caisses'"><app-kids></app-kids></div>
  <div *ngIf="message == 'Mes bons cadeaux'"><app-bons></app-bons></div>
  <div *ngIf="message == 'Profil'"><app-profil-marchand></app-profil-marchand></div>
  <div *ngIf="message == 'Aide'"><app-aide></app-aide></div>
</div>